import React, { useMemo } from "react";
import { LiveChatUser } from "@scrile/api-provider/dist/api/LivechatsProvider";
import { UserListItemIcon } from "types";
import BaseAvatar from "components/BaseAvatar";
import BaseButton from "components/BaseButton";
import BaseIcon from "components/BaseIcon";
import "./style.scss";

interface Props {
  user: LiveChatUser;
  userListItemIcon?: UserListItemIcon;
}

const UserListItem = ({ user, userListItemIcon }: Props) => {
  const defaultMuteIcon = useMemo(() => (user.muted ? "mic_off_color" : "mic_on"), [user]);
  const icon = useMemo(() => (userListItemIcon?.icon ? userListItemIcon?.icon : defaultMuteIcon), [
    userListItemIcon,
    defaultMuteIcon,
  ]);
  const showIcon = useMemo(
    () => userListItemIcon?.showIcon && !(!userListItemIcon.showIconOnMe && user.id === userListItemIcon.meId),
    [user, userListItemIcon]
  );

  return (
    <div className="users-list-item">
      <BaseAvatar className="users-list-item__avatar" size={30} user={user.user} />
      <span className="users-list-item__name">{user.screenName || user.user?.screenName}</span>
      {showIcon && (
        <BaseButton
          className="users-list-item__icon-btn"
          icon
          opacity
          onClick={() => userListItemIcon?.onIconCLick && userListItemIcon?.onIconCLick(user)}
        >
          <BaseIcon className="users-list-item__icon">{icon}</BaseIcon>
        </BaseButton>
      )}
    </div>
  );
};

export default UserListItem;
